import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dialog } from 'primereact/dialog';

import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioArchivo from '../servicios/ServicioArchivos';
import servicioPaginacion from '../servicios/ServicioPaginacion';
import servicioemisor from '../servicios/ServicioEmisor'


class Emisor extends Component {

  constructor() {
    super();
    this.state = {
      paginacion: {
        registrosPorPagina: 20,
        clase: 'com.mx.quadrum.banobras.facturacion.web.guadalara.colima.backend.entidad.fbanobrasgc.TcEmisor',
        join: [],
        conjunciones: {}
      },
      first: 0,
      emisor: {},
      errores: {},
      estado: null,
      visibleModalCertidicados: false,
      visibleModalLogo: false,
      visibleModalInformacion: false
    }
  }

  componentDidMount() {
    this.obtenerResultados();
  }


  asignarValoresObjeto = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, true);

  }

  asignarValoresObjetoSinAlterar = (event) => {
    servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this);
  }

  leerCertificado = (event) => {
    let { emisor } = this.state;
    var archivoCer = event.files[0];
    servicioArchivo.obtenerBytesBase64StringArchivo(archivoCer, emisor, 'certificado');
    this.setState(emisor);
  }

  leerLlave = (event) => {
    let { emisor } = this.state;
    var archivoCer = event.files[0];
    servicioArchivo.obtenerBytesBase64StringArchivo(archivoCer, emisor, 'llavePrivada');
    this.setState(emisor);
  }

  leerLogo = (event) => {
    let { emisor } = this.state;
    var logo = event.files[0];
    servicioArchivo.obtenerBytesBase64StringArchivo(logo, emisor, 'logo');
    this.setState(emisor);

  }

  estadosCambios = (e) => {
    this.setState({ estado: e.value });

  }

  formatoEstado = (rowData, column) => {
    let estado = rowData.estado;
    let valor = "";
    switch (estado) {
      case 0:
        valor = "Inactivo";
        break;
      case 1:
        valor = "Activo";
        break;
      default:
        valor = "E";
    }
    return <div>
      {valor}
    </div>;
  }

  obtenerResultados = () => {
    const { paginacion } = this.state;
    servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
      this.setState({ paginacion: response.data });
    });
  }

  onPage = (event) => {
    this.setState({
      first: event.first
    });
    const { paginacion } = this.state;
    paginacion.numeroPagina = event.page;
    paginacion.registrosPorPagina = event.rows;
    servicioPaginacion.paginacionGeneral(paginacion).then((response) => {
      this.setState({ paginacion: response.data });
    });
  }

  validarFormulario = (emisor, estado) => {
    const errores = {};
    if (!emisor.rfc)
      errores.rfc = "El rfc es requerido";
    if (!emisor.nombre)
      errores.nombre = "El nombre es requerido";
    if (!emisor.regimenFiscal)
      errores.regimenFiscal = "El regimen fiscal es requerido";
    if (!emisor.lugarExpedicion)
      errores.lugarExpedicion = "El lugar de expedicion es requerido";
    if (!emisor.domicilio)
      errores.domicilio = "El domicilio es requerido";
    if (!emisor.certificado)
      errores.certificado = "El certificado es requerido";
    if (!emisor.llavePrivada)
      errores.llavePrivada = "La llave privada es requerido";
    if (!emisor.clave)
      errores.clave = "La clave es requerido";
    if (!estado)
      errores.estado = "El estado es requerido";
    if (!emisor.logo)
      errores.logo = "El logo es requerido";
    return errores;
  }

  validarFormularioCertificados = (emisor) => {
    const errores = {};
    if (!emisor.certificado)
      errores.certificado = "El certificado es requerido";
    if (!emisor.llavePrivada)
      errores.llavePrivada = "La llave privada es requerido";
    if (!emisor.clave)
      errores.clave = "La clave es requerido";
    return errores;
  }

  validarFormularioLogo = (emisor) => {
    const errores = {};
    if (!emisor.logo)
      errores.logo = "El logo es requerido";
    return errores;
  }

  validarFormularioInformacion = (emisor,estado) => {
    const errores = {};
    if (!emisor.nombre)
      errores.nombre = "El nombre es requerido";
    if (!emisor.regimenFiscal)
      errores.regimenFiscal = "El regimen fiscal es requerido";
    if (!emisor.lugarExpedicion)
      errores.lugarExpedicion = "El lugar de expedicion es requerido";
    if (!emisor.domicilio)
      errores.domicilio = "El domicilio es requerido";
    if (!estado)
      errores.estado = "El estado es requerido";
      return errores;
  }

  guardar = () => {
    let { emisor, estado } = this.state;
    const validacion = this.validarFormulario(emisor, estado);
    this.setState({ errores: validacion });
    if (!Object.keys(validacion).length) {
      emisor['estado'] = estado.code;
      servicioemisor.guardar(emisor).then(response => {
        if (response.data.rfc) {
          this.setState({ emisor: {} });
          this.growl.show({ severity: 'success', summary: 'Exito', detail: response.data.rfc });
          this.obtenerResultados();
        } else {
          this.growl.show({ severity: 'error', summary: 'Error Message', detail: response.data.nombre });
        }


      }).catch(error => {
        this.growl.show({ severity: 'error', summary: 'Error Message', detail: 'Existe un error con el registro de emisor' });
      });
    }

  }

  actionCertificados = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi pi-pencil" className="p-button-success" onClick={this.mostrarModalCer.bind(this, column.rowData)}
        name="objeto" tooltip="Cambiar certificados">
      </Button>
    </div>;
  }

  actionLogo = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi pi-pencil" className="p-button-success" onClick={this.mostrarModalLogo.bind(this, column.rowData)}
        name="objeto" tooltip="Cambiar logo">
      </Button>
    </div>;
  }
  actionImformacion = (rowData, column) => {
    return <div>
      <Button type="button" icon="pi pi-pencil" className="p-button-success" onClick={this.mostrarModalInformacion.bind(this, column.rowData)}
        name="objeto" tooltip="Cambiar informacion">
      </Button>
    </div>;
  }

  mostrarModalCer = (objeto, e) => {

    const emisor = {};
    emisor['id'] = objeto.id;
    emisor['rfc'] = objeto.rfc
    this.setState({
      visibleModalCertidicados: true,
      emisor: emisor
      //estado: objeto.estado == 1 ? { name: 'Activo', code: 1 }:{ name: 'Inactivo', code: 0 }
    });

  }

  mostrarModalLogo = (objeto, e) => {
    const emisor = {};
    emisor['id'] = objeto.id;
    emisor['rfc'] = objeto.rfc
    this.setState({
      visibleModalLogo: true,
      emisor: emisor
      //estado: objeto.estado == 1 ? { name: 'Activo', code: 1 }:{ name: 'Inactivo', code: 0 }
    });

  }

  mostrarModalInformacion = (objeto, e) => {
    const emisor = {};
    emisor['id'] = objeto.id;
    emisor['nombre'] = objeto.nombre;
    emisor['regimenFiscal'] = objeto.regimenFiscal;
    emisor['lugarExpedicion'] = objeto.lugarExpedicion;
    emisor['domicilio'] = objeto.domicilio;
    const estado = objeto.estado === 1 ? { name: 'Activo', code: 1 } : { name: 'Inactivo', code: 0 };
    console.log(emisor)
    this.setState({ visibleModalInformacion: true, emisor: emisor, estado: estado });
  }

  ocultarModalCer = () => {
    this.setState({ visibleModalCertidicados: false });
  }

  ocultarModalLogo = () => {
    this.setState({ visibleModalLogo: false });
  }

  ocultarModalInformacion = () => {
    this.setState({ visibleModalInformacion: false });
  }

  actualizarCertificados = () => {
    const { emisor } = this.state;

    const validacion = this.validarFormularioCertificados(emisor);
    this.setState({ errores: validacion });
    if (!Object.keys(validacion).length) {
      servicioemisor.actualizarCertificados(emisor).then(response => {
        if (response.data.rfc) {
          this.setState({ emisor: {}, visibleModalCertidicados: false, });
          this.growl.show({ severity: 'success', summary: 'Exito', detail: response.data.rfc });
          this.obtenerResultados();
        } else {
          this.growl.show({ severity: 'error', summary: 'Error Message', detail: response.data.nombre });
        }
      }).catch(error => {

      });

    }
  }

  actualizarLogo = () => {
    const { emisor } = this.state;
    const validacion = this.validarFormularioLogo(emisor);
    this.setState({ errores: validacion });
    if (!Object.keys(validacion).length) {
      servicioemisor.actualizarLogo(emisor).then(response => {
        this.setState({ emisor: {}, visibleModalLogo: false, });
        this.growl.show({ severity: 'success', summary: 'Exito', detail: response.data.rfc });
        this.obtenerResultados();
      }).catch(error => {

      });
    }
  }

  actualizarInformacion = () => {
    const { emisor, estado } = this.state;
    const validacion = this.validarFormularioInformacion(emisor,estado);
    console.log(emisor);
    this.setState({ errores: validacion });
    if (!Object.keys(validacion).length) {
      emisor['estado'] = estado.code;
      servicioemisor.actualizarInformacion(emisor).then(response=>{
        this.setState({ emisor: {}, visibleModalInformacion: false, });
        this.growl.show({ severity: 'success', summary: 'Exito', detail: response.data.rfc });
        this.obtenerResultados();
      }).catch(error=>{

      })
    }

  }

  buscarEmisor=()=> {
    const { emisor } = this.state;
    servicioemisor.buscarEmisor(emisor).then((response) => {
        if (response.data) {
            this.growl.show({ life: 5000, severity: 'error', summary: 'Mensaje de error', detail: 'El rfc ' + emisor.rfc + ' ya se encuentra registrado' });
            this.setState({ emisor: { ...this.emisor, rfc: '' } });
        }
    }).catch((error) => {
        this.growl.show({ severity: 'error', summary: 'Mensaje', detail: 'El servidor no responde' });
    });
}


  render() {
    const { emisor, errores, paginacion, first } = this.state;

    const estados = [
      { name: 'Activo', code: 1 },
      { name: 'Inactivo', code: 0 }
    ];

    const footerCer = (
      <div>
        <Button label="Guardar" icon="pi pi-check" onClick={this.actualizarCertificados} />
        <Button label="Cancelar" icon="pi pi-times" onClick={this.ocultarModalCer} className="p-button-secondary" />
      </div>
    );

    const footerLogo = (
      <div>
        <Button label="Guardar" icon="pi pi-check" onClick={this.actualizarLogo} />
        <Button label="Cancelar" icon="pi pi-times" onClick={this.ocultarModalLogo} className="p-button-secondary" />
      </div>
    );

    const footerInformacion = (
      <div>
        <Button label="Guardar" icon="pi pi-check" onClick={this.actualizarInformacion} />
        <Button label="Cancelar" icon="pi pi-times" onClick={this.ocultarModalInformacion} className="p-button-secondary" />
      </div>
    );


    return (<div className="card card-w-title">
      <Growl ref={(el) => this.growl = el} />
      <h1>Administración de Emisores</h1>
      <h4>Los campos con (*) son obligatorios</h4>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <h4>*Rfc:</h4>
          <InputText id="rfc" name="emisor.rfc" value={emisor.rfc || ''} onChange={this.asignarValoresObjeto} className={errores.rfc ? 'p-error' : ''} onBlur={this.buscarEmisor}/>
          {errores.rfc ? <div><br /> <Message severity="error" text={errores.rfc} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-4">
          <h4>*Nombre:</h4>
          <InputText id="nombre" name="emisor.nombre" value={emisor.nombre || ''} onChange={this.asignarValoresObjeto} className={errores.nombre ? 'p-error' : ''} />
          {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-4">
          <h4>*Regimen Fiscal:</h4>
          <InputText id="regimenfiscal" name="emisor.regimenFiscal" value={emisor.regimenFiscal || ''} onChange={this.asignarValoresObjeto} className={errores.regimenFiscal ? 'p-error' : ''} />
          {errores.regimenFiscal ? <div><br /> <Message severity="error" text={errores.regimenFiscal} /> </div> : null}
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <h4>*Lugar Expedición:</h4>
          <InputText id="lugarExpedicion" name="emisor.lugarExpedicion" value={emisor.lugarExpedicion || ''} onChange={this.asignarValoresObjeto} className={errores.lugarExpedicion ? 'p-error' : ''} />
          {errores.lugarExpedicion ? <div><br /> <Message severity="error" text={errores.lugarExpedicion} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-4">
          <h4>*Domicilio:</h4>
          <InputText id="domicilio" name="emisor.domicilio" value={emisor.domicilio || ''} onChange={this.asignarValoresObjeto} className={errores.domicilio ? 'p-error' : ''} />
          {errores.domicilio ? <div><br /> <Message severity="error" text={errores.domicilio} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-4">
          <h4>*Clave CSD:</h4>
          <InputText id="clave" name="emisor.clave" value={emisor.clave || ''} onChange={this.asignarValoresObjetoSinAlterar} className={errores.clave ? 'p-error' : ''} />
          {errores.clave ? <div><br /> <Message severity="error" text={errores.clave} /> </div> : null}
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <h4>*Archivo CER</h4>
          <FileUpload id="fileCer" mode="basic" name="fileCer" chooseLabel="archivo .cer" auto={true} onSelect={this.leerCertificado} className={errores.certificado ? 'p-error' : ''} accept=".cer" />
          {errores.certificado ? <div><br /> <Message severity="error" text={errores.certificado} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-4">
          <h4>*Archivo KEY</h4>
          <FileUpload id="fileKey" mode="basic" name="fileKey" chooseLabel="archivo .key" auto={true} onSelect={this.leerLlave} className={errores.llavePrivada ? 'p-error' : ''} accept=".key" />
          {errores.llavePrivada ? <div><br /> <Message severity="error" text={errores.llavePrivada} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-4">
          <h4>*Estado</h4>
          <Dropdown value={this.state.estado} options={estados} className={errores.estado ? 'p-error' : ''} onChange={this.estadosCambios} placeholder="Selecciona estatus" optionLabel="name" autoWidth={false} />
          {errores.estado ? <div><br /> <Message severity="error" text={errores.estado} /> </div> : null}
        </div>
      </div>
      <div className="p-grid p-fluid">
        <div className="p-col-12 p-md-4">
          <h4>*Archivo Logo</h4>
          <FileUpload id="fileLogo" mode="basic" name="fileLogo" chooseLabel="imagen" auto={true} onSelect={this.leerLogo} className={errores.logo ? 'p-error' : ''} accept=".png,.jpg" />
          {errores.logo ? <div><br /> <Message severity="error" text={errores.logo} /> </div> : null}
        </div>
        <div className="p-col-12 p-md-4 p-offset-4">
          <br /> <br /> <br />
          <Button label="Guardar" className="p-button-rounded p-button-warning" onClick={this.guardar} />
        </div>
      </div>
      <Card>
        <DataTable value={paginacion.datos} editable={true} selectionMode="single" scrollable={true} scrollHeight="220px"  >
          <Column field="rfc" header="RFC" style={{ width: '200px' }} filter={false} autoLayout={true} />
          <Column field="nombre" header="Nombre" style={{ width: '200px' }} filter={false} autoLayout={true} />
          <Column field="regimenFiscal" header="Regimen Fiscal" style={{ width: '200px' }} filter={false} autoLayout={true} />
          <Column field="lugarExpedicion" header="Lugar Expedición" style={{ width: '200px' }} filter={false} autoLayout={true} />
          <Column field="domicilio" header="Domicilio" style={{ width: '200px' }} filter={false} />
          <Column body={this.formatoEstado} header="Estado Emisor" style={{ width: '110px' }} />
          <Column header="Cambiar certificados" body={this.actionCertificados} style={{ textAlign: 'center', width: '12em' }} />
          <Column header="Cambiar logo" body={this.actionLogo} style={{ textAlign: 'center', width: '12em' }} />
          <Column header="Cambiar información" body={this.actionImformacion} style={{ textAlign: 'center', width: '12em' }} />
        </DataTable>
        <Paginator totalRecords={paginacion.registrosTotales} rows={paginacion.registrosPorPagina} first={first} onPageChange={this.onPage} rowsPerPageOptions={[20, 40, 60, 80, 100]}></Paginator>
      </Card>
      <Dialog header="Editar certificados" visible={this.state.visibleModalCertidicados} style={{ width: '50vw' }} footer={footerCer} onHide={this.ocultarModalCer}>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            <h4>*Rfc:</h4>
            <InputText id="rfc" name="emisor.rfc" value={emisor.rfc || ''} onChange={this.asignarValoresObjeto} className={errores.rfc ? 'p-error' : ''} disabled />
            {errores.rfc ? <div><br /> <Message severity="error" text={errores.rfc} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>*Clave CSD:</h4>
            <InputText id="clave" name="emisor.clave" value={emisor.clave || ''} onChange={this.asignarValoresObjetoSinAlterar} className={errores.clave ? 'p-error' : ''} />
            {errores.clave ? <div><br /> <Message severity="error" text={errores.clave} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>*Archivo CER</h4>
            <FileUpload id="fileCer" mode="basic" name="fileCer" chooseLabel="archivo .cer" auto={true} onSelect={this.leerCertificado} className={errores.certificado ? 'p-error' : ''} accept=".cer" />
            {errores.certificado ? <div><br /> <Message severity="error" text={errores.certificado} /> </div> : null}
          </div>
        </div>
        <div className="p-grid p-fluid">

          <div className="p-col-12 p-md-4">
            <h4>*Archivo KEY</h4>
            <FileUpload id="fileKey" mode="basic" name="fileKey" chooseLabel="archivo .key" auto={true} onSelect={this.leerLlave} className={errores.llavePrivada ? 'p-error' : ''} accept=".key" />
            {errores.llavePrivada ? <div><br /> <Message severity="error" text={errores.llavePrivada} /> </div> : null}
          </div>
        </div>
      </Dialog>
      <Dialog header="Editar logo" visible={this.state.visibleModalLogo} style={{ width: '50vw' }} footer={footerLogo} onHide={this.ocultarModalLogo}>
        <div className="p-grid p-fluid">
          <div className="p-col p-col-align-center">
            <h4>*Archivo Logo</h4>
            <FileUpload id="fileLogo" mode="basic" name="fileLogo" chooseLabel="imagen" auto={true} onSelect={this.leerLogo} className={errores.logo ? 'p-error' : ''} accept=".png,.jpg" />
            {errores.logo ? <div><br /> <Message severity="error" text={errores.logo} /> </div> : null}
          </div>
        </div>
      </Dialog>
      <Dialog header="Editar información" visible={this.state.visibleModalInformacion} style={{ width: '50vw' }} footer={footerInformacion} onHide={this.ocultarModalInformacion}>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            <h4>*Nombre:</h4>
            <InputText id="nombre" name="emisor.nombre" value={emisor.nombre || ''} onChange={this.asignarValoresObjeto} className={errores.nombre ? 'p-error' : ''} />
            {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>*Regimen Fiscal:</h4>
            <InputText id="regimenfiscal" name="emisor.regimenFiscal" value={emisor.regimenFiscal || ''} onChange={this.asignarValoresObjeto} className={errores.regimenFiscal ? 'p-error' : ''} />
            {errores.regimenFiscal ? <div><br /> <Message severity="error" text={errores.regimenFiscal} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>*Lugar Expedición:</h4>
            <InputText id="lugarExpedicion" name="emisor.lugarExpedicion" value={emisor.lugarExpedicion || ''} onChange={this.asignarValoresObjeto} className={errores.lugarExpedicion ? 'p-error' : ''} />
            {errores.lugarExpedicion ? <div><br /> <Message severity="error" text={errores.lugarExpedicion} /> </div> : null}
          </div>
        </div>
        <div className="p-grid p-fluid">
          <div className="p-col-12 p-md-4">
            <h4>*Domicilio:</h4>
            <InputText id="domicilio" name="emisor.domicilio" value={emisor.domicilio || ''} onChange={this.asignarValoresObjeto} className={errores.domicilio ? 'p-error' : ''} />
            {errores.domicilio ? <div><br /> <Message severity="error" text={errores.domicilio} /> </div> : null}
          </div>
          <div className="p-col-12 p-md-4">
            <h4>*Estado</h4>
            <Dropdown value={this.state.estado} options={estados} className={errores.estado ? 'p-error' : ''} onChange={this.estadosCambios} placeholder="Selecciona estatus" optionLabel="name" autoWidth={false} />
            {errores.estado ? <div><br /> <Message severity="error" text={errores.estado} /> </div> : null}
          </div>
        </div>
      </Dialog>
    </div>);
  }
}
export default Emisor;